import { useState } from 'react';
import {
    Box,
    FormControl,
    OutlinedInput,
    InputAdornment,
} from "custom_exports/material_ui_items";
import { MdSearch } from "react-icons/md";

function SearchField({ onSearch }) {
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        if (onSearch) {
            onSearch(query);
        }
    };

    return (
        <Box sx={{ width: "100%", ml: { xs: 0, md: 1 } }}>
            <FormControl sx={{ width: { xs: "100%", md: 180 } }}>
                <OutlinedInput
                    id="header-search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search ..."
                    startAdornment={
                        <InputAdornment position="start">
                            <MdSearch style={{ height: 18, width: 18 }} />
                        </InputAdornment>
                    }
                    sx={{ height: 45  }}
                />
            </FormControl>
        </Box>
    );
}

export default SearchField;
